module.exports = __webpack_public_path__ + "static/img/andoridDownload.043ae164.png";